import {
    ContentDetailInfoShell,
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailKvListValue,
    DetailPanel,
    DetailKvTable,
    DetailSummaryPrintButton,
    KV_LIST_TYPES,
} from '../../../../components/detailLayout';
import React, {useEffect, useState} from "react";
import Th_title from "../../../../components/Th_title";
import {ContentCategory} from "../../../../constant/CodeSpecNum";
import ReadOnlyInputBasic from "../../../../components/input/ReadOnlyInputBasic";
import {
    getWorkResult,
    removeWorkResult,
    saveWorkResult,
    updateWorkResult
} from "../../../../api/maintenance/WorkService";
import {connectedInfoRadio} from "../WorkCreate";
import SignContainer from "../../../../components/basic/SignContainer";
import {isEmpty} from "../../../../components/commonmethod/CommonMethod";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import {cn} from "../../../../shadCn/lib/utils";
import {inputOnChange} from "../../../../components/commonmethod/simmsInputMethod";
import SimmsTextArea from "../../../../components/input/SimmsTextArea";

function WorkResultReport({id, work, assets, handler, statusNumericValue}){
    const [workResult, setWorkResult] = useState({});
    const [docs, setDocs] = useState([]);

    const remove = async () =>{
        const response = await removeWorkResult({id : workResult.id});
        if (response.status === 200) {
            setWorkResult({})
            alert("작업결과서가 정상적으로 삭제되었습니다.");
        }
    }

    const cancel={
        url:"/maintenance/work"
    }

    useEffect(() => {
        getWorkResult(id).then((response) => {
            setWorkResult(response.data)
        });
    }, [id])

    useEffect(() =>{
        getWorkResult(id).then((response) => {
            setWorkResult(response.data)
        });
    }, [workResult?.id])

    const create = async ()=>{
        const docFile=[]
        docs.forEach(each=>docFile.push(each.object))

        const data = {
            ...workResult,
            work: {id : id}
        };

        await saveWorkResult(data, docFile).then(response => {
            if(response.status === 200){
                setWorkResult(response.data);
                alert("등록되었습니다.")
            }
        });
    }

    const update = async ()=>{
        const data = {
            ...workResult,
            work: {id : id}
        };

        await updateWorkResult(data).then(response => {
            if(response.status === 200){
                alert("수정되었습니다.")
            }
        });
    }


    const summaryMeta = [
        work.workCode?.name && `코드 ${work.workCode.name}`,
        work.requester?.name && `요청 ${work.requester.name}`,
    ].filter(Boolean).join(" · ");

    const requestInfoPanel = (
        <DetailPanel title={"작업요청정보"}>
            <DetailKvTable>
                <tbody>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title={"자산목록"} colspan={3} className="fieldset-td relative align-top">
                            <DetailKvListValue items={assets} listType={KV_LIST_TYPES.asset} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"작업연계정보"} colspan={3} className="fieldset-td relative align-top">
                            <ReadOnlyInputBasic target={"connectedInfo"} value={connectedInfoRadio.find(each => each.value === work.connectedInfo)?.text} />
                        </Th_title>
                    </tr>
                    {
                        work?.connectedId && work?.connectedInfo && (!isEmpty(work.service) || !isEmpty(work.inspect) || !isEmpty(work.incident)) ?
                            <tr>
                                <Th_title title={"연계정보"} colspan={3} className="fieldset-td relative align-top">
                                    <div>제목 : {work.connectedInfo === ContentCategory.SERVICE_REQUEST ? work.service.title : work.connectedInfo === ContentCategory.INSPECTION ? work.inspect.title : work.connectedInfo === ContentCategory.INCIDENT ? work.incident.title : ""}</div>
                                    <div>등록일 : {work.connectedInfo === ContentCategory.SERVICE_REQUEST ? work.service.createdAt : work.connectedInfo === ContentCategory.INSPECTION ? work.inspect.createdAt : work.connectedInfo === ContentCategory.INCIDENT ? work.incident.createdAt : ""}</div>
                                    <div>수정일 : {work.connectedInfo === ContentCategory.SERVICE_REQUEST ? work.service.updatedAt : work.connectedInfo === ContentCategory.INSPECTION ? work.inspect.updatedAt : work.connectedInfo === ContentCategory.INCIDENT ? work.incident.updatedAt : ""}</div>
                                </Th_title>
                            </tr> :
                            <tr>
                                <Th_title title={"연계정보"} colspan={3} className="fieldset-td relative align-top">
                                    <div>삭제된 정보입니다.</div>
                                </Th_title>
                            </tr>
                    }
                    <tr>
                            <Th_title title={"등록일시"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"createdAt"} value={work.createdAt} />
                            </Th_title>
                            <Th_title title={"등록자"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"createdBy"} value={work.createdBy} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"수정일시"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"updatedAt"} value={work.updatedAt} />
                            </Th_title>
                            <Th_title title={"수정자"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"updatedBy"} value={work.updatedBy} />
                            </Th_title>
                        </tr>

                        <tr>
                            <Th_title title={"요청자"} colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target={"requester"} value={work.requester} />
                            </Th_title>
                        </tr>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"담당자"} colspan={3} className="fieldset-td fieldset-td-input relative align-top">
                                <DetailKvListValue items={handler} listType={KV_LIST_TYPES.user} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"작업종류"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"workCode"} value={work.workCode.name} />
                            </Th_title>
                            <Th_title title={"요청방식"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"workRequest"} value={work.workRequest} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"작업인지"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"workAcceptCode"} value={work.workAcceptCode} />

                                <ReadOnlyInputBasic target={"workAcceptText"} value={work.workAcceptText} />
                            </Th_title>
                            <Th_title title={"작업위치"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"location"} value={work.location} />
                            </Th_title>
                        </tr>

                        <tr>
                            <Th_title title={"작업기간"} colspan={3} className="fieldset-td fieldset-td-input">
                                <div className={"web-flex"}>
                                    <SimmsDatePicker data={work.workStartDate} readonly />
                                    <span className={cn("ml-2 mr-1 text-[20px]")}> ~ </span>
                                    <SimmsDatePicker data={work.workEndDate} readonly />
                                </div>
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"작업 제목"} colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target={"title"} value={work.title} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"작업내용"} colspan={3} className="fieldset-td">
                                <div className={`align-text-div`}>{work.workContent}</div>
                            </Th_title>
                        </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const resultContentPanel = (
                <DetailPanel title={"작업결과내용"}>
                    <DetailKvTable>
                        <tbody>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"작업결과"} colspan={3} className="fieldset-td" auth={work.auth.update}>
                                <SimmsTextArea
                                    onChange={(v)=>inputOnChange(setWorkResult,"workResult", v, false)}
                                    data={workResult.workResult} style={{width: "100%", minHeight:"80px"}}
                                    placeHolder={`${workResult?.id ? '' : '데이터를 입력해주세요'}`}
                                />
                            </Th_title>
                        </tr>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"세부작업내용"} colspan={3} className="fieldset-td" auth={work.auth.update}>
                                <SimmsTextArea
                                    onChange={(v)=>inputOnChange(setWorkResult,"additionalContent", v, false)}
                                    data={workResult.additionalContent} style={{width: "100%", minHeight:"80px"}}
                                    placeHolder={`${workResult?.id ? '' : '데이터를 입력해주세요'}`}
                                />
                            </Th_title>
                        </tr>
                        </tbody>
                    </DetailKvTable>
                </DetailPanel>
    );

    const asidePanel = (
        <>
            <SignContainer contentId={work.id} contentCategory={"WORK"} statusNumericValue={statusNumericValue} />
            <DetailFilePanel
                title="첨부"
                isEditing={Boolean(work.auth?.update)}
                showFileLabel={false}
                tableInfo={workResult?.id ? {tableName: "work_result", joinKey: workResult.id} : undefined}
                pendingFiles={workResult?.id ? undefined : {files: docs, setFiles: setDocs}}
                pendingInputId="work_result_pending_doc"
            />
        </>
    );

    return (
        <ContentDetailInfoShell
            title={work?.title || "작업결과서"}
            meta={summaryMeta || work?.serialNumber}
            contentId={id}
            contentCategory={ContentCategory.WORK}
            scrollMode="columns"
            trackActions
            listUrl="/maintenance/work"
            actions={<DetailSummaryPrintButton />}
            rollup={{
                cancel,
                data: work,
                remove: work.auth?.update && workResult?.id ? remove : "",
                create: work.auth?.update && workResult?.id ? "" : create,
                update: work.auth?.update && workResult?.id ? update : "",
            }}
        >
            <ContentDetailThreeColLayout
                primary={requestInfoPanel}
                secondary={resultContentPanel}
                aside={asidePanel}
            />
        </ContentDetailInfoShell>
    );
}

export {WorkResultReport}